import 'intersection-observer';
import * as LX from '@utils/lxWrapper';

/**
 * 监听元素配置项
 * root:外层包裹元素
 * threshold:元素露出阈值
 * rootMargin：根元素边距
 */
type interSectionObserverOption = {
    root?: any;
    rootMargin?: string;
    threshold?: number;
};

/**
 * 创建菜单项元素监听
 * @param option
 * @returns
 */
function createMenuObserver(option?: interSectionObserverOption) {
    return new IntersectionObserver(entries => {
        entries.forEach(item => {
            if (item.isIntersecting && item.target.innerHTML) {
                LX.reportMV('b_waimai_e_92z6k2kp_mv', 'c_waimai_e_fa4ps4ng', {
                    bMenuName: item.target.id,
                });
            }
        });
    }, option);
}
export default createMenuObserver;
